import React, { PureComponent } from 'react'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { userActions } from '../../../redux/actions/user'
import { notificationsActions } from '../../../redux/actions/notifications'
import PropTypes from 'prop-types'
import Layer from '../../Shared/Layer'
import Icon from '../../Shared/Icon'
import { Link } from 'react-router-dom'
import { ReactComponent as BellIcon } from '../../../assets/img/icons/bell.svg'

class Header extends PureComponent {
  state = {
    showContactUsLayer: false
  }

  render () {
    const { t } = this.props
    const hotelName = this.props.property?.name
    const hotelLocation = this.props.property
      ? this.props.property.city.name
      + ' | ' + this.props.property.destination.name
      + ' | ' + this.props.property.country.name
      : null

    return (
      <header className="mygiata_header">
        <div className="app-header">
          <div className="app-header__logo-container">
            <Link className="app-header__logo" to="/properties-list"/>
          </div>

          <div className="app-header__top-bar">
            <div className="app-header__hotel-info">
              {hotelName && <h1 className="hotel-name">{hotelName}</h1>}
              {hotelLocation && <p className="hotel-location">{hotelLocation}</p>}
            </div>

            {
              this.props.loggedIn && <div className="app-header__actions">
                {
                  this.props.property && <button
                    className="app-header__notifications"
                    type="button"
                    aria-label={t('notificationCenter.title')}
                    aria-haspopup="dialog"
                    onClick={this.props.toggleNotifications}
                  >
                    <BellIcon aria-hidden="true"/>
                    {
                      this.props.notificationsUnreadCount > 0 && <span
                        className="app-header__notifications-badge"
                        aria-hidden="true"
                      >
                    {this.props.notificationsUnreadCount > 9 ? '9+' : this.props.notificationsUnreadCount}
                  </span>
                    }
                  </button>
                }
                <button
                  className="app-header__logout"
                  onClick={this.props.logout}
                  type="button"
                >
                  Logout
                </button>
              </div>
            }
          </div>
        </div>
        {this.state.showContactUsLayer &&
          <Layer type="center" size="small" id={'contact-us-layer'}
                 show={true}
                 onHideClick={() => this.setState({ showContactUsLayer: false })}>
            <div>
              <h2>{t('CONTACT_US')}</h2>
              <div>
                Please do not hesitate to contact the GIATA Hotel Content Team for assistance at any time.
                Outside our general office hours between Monday and Friday from 7 a.m. and 7 p.m CET,
                please leave your details for us to respond to your enquiry as soon as possible.
              </div>
              <div className="list">
                <div className="entry">
                  <div className="entry-image">
                    <a href="mailto:hotels@giata.com">
                      <Icon type={'envelope'}/>
                    </a>
                  </div>
                  <div className="entry-value">
                    <a href="mailto:hotels@giata.com">hotels@giata.com</a></div>
                </div>
                <div className="entry">
                  <div className="entry-image">
                    <a href="tel:+493042026555">
                      <Icon type={'phone'}/>
                    </a>
                  </div>
                  <div className="entry-value"><a href="tel:+493042026555">+49 30 420 265 55</a></div>
                </div>
              </div>
            </div>
          </Layer>
        }
      </header>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loggedIn: !!state.user.loggedIn,
    notificationsUnreadCount: state.notifications.items.filter(n => !n.read).length,
  }
}

const mapDispatchToProps = {
  logout: userActions.logout,
  toggleNotifications: notificationsActions.toggle,
}

Header.propTypes = {
  property: PropTypes.object,
  loggedIn: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  notificationsUnreadCount: PropTypes.number,
  toggleNotifications: PropTypes.func.isRequired,
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Header))
